import { useEffect, useMemo } from "react";

import { Link, useLocation } from "react-router-dom";

import { PlusIcon, XMarkIcon } from "@heroicons/react/24/outline";

import useContactSingle from "../../data/useContactsSingle";
import { CheckFeatureFlag } from "../../hooks/useFeatureFlag";
import useCustomerDetails from "../../data/useCustomerDetails";
import VehicleTable from "../../components/vehicles/VehicleTable";
import VehicleStats from "../../components/vehicles/VehicleStats";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { LinkButton } from "../../components/shared/Inputs/LinkButton";
import VehicleTableTme from "../../components/vehicles/VehicleTableTme";


export default function VehicleList() {
  const { features } = useCustomerDetails();
  const location = useLocation();
  const { setInfo } = usePageNameContext();
  // const { vehicles: allVehicles } = useVehicles();
  const { contact } = useContactSingle(location.state ? location.state?.filter?.contactId ?? "" : "");


  const isTme = CheckFeatureFlag("TME");

  const hasLeads = useMemo(() => {
    return features.data?.data?.find((f) => f.name === "Lead Management");
  }, [features.data]);

  useEffect(() => {
    if (location.state?.filter && !contact.isLoading) {
      let foundContact = contact.data;
      setInfo({
        name: `Vehicles for ${foundContact?.data.fullname}`,
        desc: "View and manage filtered vehicles here",
      });
    } else {
      setInfo({
        name: "Vehicles",
        desc: "View and manage all vehicles here",
      });
    }
  }, [location, contact.isLoading]);

  return (
    <>
      <VehicleStats />
      <div className="flex items-center justify-between my-4">
        <div>
          {location.state?.filter && (
            <Link
              to={"/vehicles"}
              replace={true}
              state={undefined}
              className="inline-flex items-center rounded-md border border-transparent bg-primary-600 px-3 py-2 text-sm font-medium leading-4 text-white shadow-sm hover:bg-primary-700"
            >
              <XMarkIcon className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
              Clear filter
            </Link>
          )}
        </div>

        <LinkButton
          to={hasLeads ? "/leads/create-multiple" : "/vehicles/create"}
          label={hasLeads ? "Create Lead" : "Create Vehicle"}
          classes="inline-flex items-center"
        >
          <PlusIcon className="-ml-0.5 mr-2 h-4 w-4" aria-hidden="true" />
        </LinkButton>


      </div >
      {/* <VehicleTable additionalBody={{ ...(hasLeads ? { isScheduled: true, isCollected: false } : {}), ...clickedFilter, includeUnscheduled: true }} /> */}

      {isTme ? (
        <VehicleTableTme additionalBody={{}} />
      ) : (
        <VehicleTable additionalBody={{}} />
      )}

    </>
  );
}
